import { Injectable, signal, computed, effect } from '@angular/core';
import { Signal } from '@angular/core';
import { Router } from '@angular/router';

interface NavigationAttempt {
  attempted: boolean;
  url?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NavLockService {
  private locked = signal(false);
  private navigationAttempted = signal<NavigationAttempt>({ attempted: false });

  isLocked: Signal<boolean> = computed(() => this.locked());

  constructor(private router: Router) {}

  setLock(locked: boolean) {
    this.locked.set(locked);
  }

  notifyNavigationAttempt(url: string) {
    if (this.locked()) {
      this.navigationAttempted.set({ attempted: true, url });
      return true;
    }
    return false;
  }

  resetNavigationAttempt() {
    this.navigationAttempted.set({ attempted: false });
  }

  onNavigationAttempt(callback: (url: string) => void) {
    return effect(() => {
      const attempt = this.navigationAttempted();
      if (attempt.attempted && attempt.url) {
        callback(attempt.url);
        queueMicrotask(() => this.resetNavigationAttempt());
      }
    });
  }

  async navigateToAttemptedRoute(url: string) {
    await this.router.navigate([url]);
  }
}